export default __webpack_public_path__ + "static/media/horizontal.1461844a.svg";